export class EnquiryFormComponent {
    protected $root: JQuery;

    constructor(elem: HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    bindUI = () => {
        this.$root.on({'recaptcha-ready': this.setupRecaptcha});
    };

    setupRecaptcha = () => {
        let $recaptcha = this.$root.find('.js-recaptcha').first();
        if ($recaptcha.length > 0) {
            this.$root.on({
                submit: (event: any) => {
                    event.preventDefault();
                    // @ts-ignore
                    grecaptcha.execute().then(this.handleSubmit);
                }
            });
            grecaptcha.render($recaptcha.attr("id"), {
                "sitekey": (<any>window).params['recaptcha_key'],
                'badge': 'inline',
                'size': 'invisible'
            });
        } else {
            this.$root.on({submit: this.handleSubmit});
        }
    };

    handleSubmit = () => (<HTMLFormElement>this.$root.get(0)).submit();
}